<template>
  <div class="safedig-whats-new">
    <h1 class="safedig-page-title">{{ $t('whatsNew.title') }}</h1>

    <div class="safedig-content-box">
      <h2 class="safedig-content-box-header">{{ $t('whatsNew.welcomeTitle') }}</h2>
      <div class="safedig-content-box-body">
        <p>
          {{ $t('whatsNew.welcomePara1') }}
        </p>
        <p>
          {{ $t('whatsNew.welcomePara2') }}
        </p>
        <p>
          {{ $t('whatsNew.welcomePara3') }}
        </p>
        <p>
          {{ $t('whatsNew.welcomePara4Before') }}
          <router-link to="/info/contact_us">{{ $t('whatsNew.contactHere') }}</router-link>
          {{ $t('whatsNew.welcomePara4After') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SafeDigWhatsNew'
};
</script>

<style scoped>
.safedig-whats-new {
  max-width: 800px;
}

.safedig-page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e3a5f;
  margin-bottom: 1.5rem;
  line-height: 1.3;
}

.safedig-content-box {
  border: 1px solid #c5d4e2;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.safedig-content-box-header {
  margin: 0;
  padding: 6px 15px;
  font-size: 18px;
  font-weight: 600;
  color: #154e6f;
  background: #94bcd5;
  border-bottom: 1px solid #94bcd5;
}

.safedig-content-box-body {
  padding: 15px;
}

.safedig-content-box-body p {
  font-size: 0.95rem;
  color: #4b5563;
  line-height: 1.6;
  margin: 0 0 1rem;
}

.safedig-content-box-body p:last-child {
  margin-bottom: 0;
}

.safedig-content-box-body a {
  color: #3e7799;
  text-decoration: none;
}

.safedig-content-box-body a:hover {
  text-decoration: underline;
}
</style>
